(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ask-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ask]');
    if (!root) return;
    var panel = root.querySelector('[data-ask-panel]');
    var toggle = root.querySelector('[data-ask-toggle]');

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = panel.querySelector('input, textarea');
        if (first) first.focus();
      }
    }

    toggle.addEventListener('click', function () { setOpen(panel.hidden); });
    root.querySelector('[data-ask-close]').addEventListener('click', function () {
      setOpen(false);
      toggle.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });

    // Shopify redirects back with ?contact_posted=true — open the panel so the
    // sender actually sees the confirmation instead of a silently reset page.
    if (root.hasAttribute('data-ask-open')) setOpen(true);

    // watch the promo bar so the two never sit on top of each other
    var promo = document.querySelector('[data-floating-promo]');
    if (promo) {
      var sync = function () {
        document.body.classList.toggle('has-floating-promo', promo.classList.contains('is-visible'));
      };
      new MutationObserver(sync).observe(promo, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function initFeaturedRails(scope) {
    (scope || document).querySelectorAll('.featured-collection__viewport').forEach(function (view) {
      if (view.dataset.railReady) return;
      view.dataset.railReady = 'true';

      var rail = view.querySelector('[data-scroller]');
      var prev = view.querySelector('[data-fc-prev]');
      var next = view.querySelector('[data-fc-next]');
      if (!rail || !prev || !next) return;

      function overflows() { return rail.scrollWidth - rail.clientWidth > 4; }

      function sync() {
        if (!overflows()) {                 // fewer products than fit: no controls at all
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = rail.scrollLeft <= 2;
        next.hidden = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      }

      function step(dir) {
        var card = rail.querySelector('.featured-collection__item');
        var by = card ? card.getBoundingClientRect().width * 2 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * by, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initFeaturedRails(); });
  document.addEventListener('shopify:section:load', function (e) { initFeaturedRails(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-floating-promo]').forEach(function (el) {
        if (el.dataset.ready) return;
        el.dataset.ready = 'true';

        var key = el.dataset.key || 'momomoca-promo';
        var dismissed = false;
        try { dismissed = localStorage.getItem(key) === 'dismissed'; } catch (e) {}
        // the theme editor should always show it, even after a dismissal
        var inEditor = window.Shopify && window.Shopify.designMode;
        if (dismissed && !inEditor) return;

        var after = parseInt(el.dataset.showAfter, 10) || 600;
        var shown = false;

        function reveal() {
          if (shown) return;
          shown = true;
          el.hidden = false;
          requestAnimationFrame(function () { el.classList.add('is-visible'); });
          window.removeEventListener('scroll', onScroll);
        }
        function onScroll() {
          if (window.scrollY > after) reveal();
        }

        el.querySelector('[data-floating-promo-close]').addEventListener('click', function () {
          el.classList.remove('is-visible');
          try { localStorage.setItem(key, 'dismissed'); } catch (e) {}
          setTimeout(function () { el.hidden = true; }, 400);
        });

        if (inEditor) { reveal(); return; }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-slider-track]');
      this.slides = Array.from(root.querySelectorAll('[data-slider-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
      this.current = root.querySelector('[data-slider-current]');
      this.index = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = root.dataset.autoplay === 'true' && !this.reduced;
      this.interval = parseInt(root.dataset.interval, 10) || 6000;

      this.bind();
      this.start();
    }

    bind() {
      const prev = this.root.querySelector('[data-slider-prev]');
      const next = this.root.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.sliderDot, 10), true));
      });

      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1, true); }
      });

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());

      // touch swipe
      let startX = null;
      this.root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.root.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) this.step(dx < 0 ? 1 : -1, true);
        startX = null;
      }, { passive: true });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });
    }

    step(delta, userInitiated) {
      const total = this.slides.length;
      this.go((this.index + delta + total) % total, userInitiated);
    }

    go(index, userInitiated) {
      this.index = index;
      this.track.style.transform = 'translateX(-' + index * 100 + '%)';

      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('aria-hidden', i !== index);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (this.current) this.current.textContent = index + 1;

      if (userInitiated) this.restart();
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.step(1, false), this.interval);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  function initHeroSliders(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach((el) => {
      if (el.dataset.sliderReady) return;
      el.dataset.sliderReady = 'true';
      new HeroSlider(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initHeroSliders());
  // re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', (e) => initHeroSliders(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.reels');
    if (!section) return;
    var rail = section.querySelector('[data-reels-rail]');
    var prev = section.querySelector('[data-reels-prev]');
    var next = section.querySelector('[data-reels-next]');
    var videos = [].slice.call(section.querySelectorAll('.reels__video'));

    /* ---- arrows ---- */
    function step() {
      var card = rail.querySelector('.reels__item');
      var w = card ? card.getBoundingClientRect().width + 10 : rail.clientWidth;
      return Math.max(w, Math.floor(rail.clientWidth / w) * w);
    }
    function sync() {
      var over = rail.scrollWidth - rail.clientWidth > 4;
      prev.hidden = !over || rail.scrollLeft <= 2;
      next.hidden = !over || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* ---- autoplay ----
       Two reasons not to autoplay: the visitor asked for less motion, or they
       are on a metered connection. Both leave the poster frame in place, which
       is a perfectly good thumbnail. */
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection || {};
    var saveData = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
    if (reduced || saveData || !('IntersectionObserver' in window)) return;

    /* warm the file up before it is on screen, so play() is not a black frame */
    var warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.target.preload === 'none') e.target.preload = 'auto';
      });
    }, { rootMargin: '400px 0px' });

    var play = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          /* a rejected play() is normal -- the tab is hidden, or the browser
             declined. Swallow it rather than throwing on every scroll. */
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
          /* a muted reel that scrolled away should start over, not resume
             halfway through with no context */
          if (v.muted) v.currentTime = 0;
        }
      });
    }, { threshold: 0.6 });

    videos.forEach(function (v) { warm.observe(v); play.observe(v); });

    /* ---- sound ---- */
    section.querySelectorAll('[data-reels-sound]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        /* the card is a link; a tap on the speaker must not navigate */
        e.preventDefault();
        e.stopPropagation();
        var v = btn.closest('.reels__media').querySelector('.reels__video');
        var on = v.muted;
        /* only one reel talks at a time */
        if (on) {
          videos.forEach(function (other) { if (other !== v) other.muted = true; });
          section.querySelectorAll('[data-reels-sound]').forEach(function (b) {
            if (b !== btn) setIcon(b, false);
          });
        }
        v.muted = !on;
        setIcon(btn, on);
        if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    function setIcon(btn, soundOn) {
      btn.setAttribute('aria-pressed', String(soundOn));
      btn.querySelector('.reels__sound-off').hidden = soundOn;
      btn.querySelector('.reels__sound-on').hidden = !soundOn;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (function () {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var key = 'momomoca-wishlist-' + grid.dataset.customer;

    function read() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    var PAW =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<ellipse cx="12" cy="16.4" rx="5.4" ry="4.3"/>' +
        '<ellipse cx="6.1" cy="10.6" rx="2.4" ry="3"/>' +
        '<ellipse cx="17.9" cy="10.6" rx="2.4" ry="3"/>' +
        '<ellipse cx="9.4" cy="6.3" rx="2.2" ry="2.9"/>' +
        '<ellipse cx="14.6" cy="6.3" rx="2.2" ry="2.9"/>' +
      '</svg>';

    function refreshCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = c.item_count;
        });
      }).catch(function () {});
    }

    function buyControl(p) {
      var sellable = (p.variants || []).filter(function (v) { return v.available; });
      if (!p.available || !sellable.length) {
        return '<button type="button" class="wishlist__atc" disabled>Sold out</button>';
      }
      /* more than one buyable variant means a choice we must not make for them —
         adding "whichever came first" is how people receive the wrong size */
      if (sellable.length > 1) {
        return '<a class="wishlist__atc wishlist__atc--choose" href="/products/' + p.handle + '">Choose options</a>';
      }
      return '<button type="button" class="wishlist__atc" data-variant="' + sellable[0].id + '">Add to cart</button>';
    }

    function card(p) {
      var el = document.createElement('div');
      el.className = 'wishlist__card';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      el.innerHTML =
        '<button type="button" class="wishlist__remove" aria-label="Remove from wishlist">' + PAW + '</button>' +
        '<a class="wishlist__media" href="/products/' + p.handle + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a href="/products/' + p.handle + '"><p class="wishlist__title">' + p.title + '</p></a>' +
        '<p class="wishlist__price' + (p.available ? '' : ' wishlist__sold') + '">' +
          (p.available ? money(p.price) : 'Sold out') + '</p>' +
        buyControl(p);

      el.querySelector('.wishlist__remove').addEventListener('click', function () {
        write(read().filter(function (h) { return h !== p.handle; }));
        el.remove();
        if (!grid.children.length && empty) empty.hidden = false;
      });

      var atc = el.querySelector('button.wishlist__atc[data-variant]');
      if (atc) {
        atc.addEventListener('click', function () {
          atc.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(atc.dataset.variant), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            atc.textContent = 'Added';
            refreshCartCount();
            setTimeout(function () { atc.textContent = 'Add to cart'; atc.disabled = false; }, 1600);
          }).catch(function () {
            atc.textContent = 'Try again';
            atc.disabled = false;
          });
        });
      }
      return el;
    }

    var handles = read();
    if (!handles.length) { if (empty) empty.hidden = false; return; }

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      /* a handle that no longer resolves was deleted upstream; drop it rather
         than leaving a dead card the shopper cannot act on */
      var alive = [];
      items.forEach(function (p) {
        if (!p) return;
        alive.push(p.handle);
        grid.appendChild(card(p));
      });
      if (alive.length !== handles.length) write(alive);
      if (!alive.length && empty) empty.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
